import SelectCourse from './SelectCourse';

export default SelectCourse;
